"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import { displayDate, isBeforeToday } from "@repo/design-system/utils/date-helpers";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import PrivacyNotice from "~/components/job-page/jobadtemplate/privacy-notice-eon";
import { LocationDisplay } from "~/components/ui/location-display-eon";
import { PrintDropdown } from "~/components/ui/print-dropdown-eon";
import ShareDropdown from "~/components/ui/share-dropdown-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import KununuBoxEcon from "./kununu-box-econ";
export default function JobAdTemplateEcon(t0) {
  const $ = _c(123);
  const {
    job
  } = t0;
  const t = useLanguage();
  const data = job.data;
  const displayLocale = t.i18n === "de" ? "de" : "en";
  let t1;
  if ($[0] !== data.applicationEnd) {
    t1 = data.applicationEnd && !isBeforeToday(data.applicationEnd);
    $[0] = data.applicationEnd;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showDeadline = t1;
  let t2;
  if ($[2] !== data.applicationEnd || $[3] !== displayLocale || $[4] !== t) {
    t2 = data.applicationEnd ? displayDate(data.applicationEnd.slice(0, 10), t, displayLocale) : null;
    $[2] = data.applicationEnd;
    $[3] = displayLocale;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const deadline = t2;
  let t3;
  if ($[6] !== data.title) {
    t3 = <h2 className="mb-4 font-bold text-4xl text-primary md:text-5xl" data-source="job">{data.title}</h2>;
    $[6] = data.title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !data.locations || data.locations.length === 1 ? `${t.jobad_locationDisplay_single}: ` : `${t.jobad_locationDisplay_multi}: `;
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="font-medium" data-source="lc">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== job) {
    t6 = <LocationDisplay job={job} showAll={true} />;
    $[10] = job;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="mb-10 text-lg">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("grid-cols-2 gap-x-24 text-foreground text-xl md:text-lg lg:grid lg:grid-cols-[minmax(0,1fr)_400px] xl:gap-x-32", "[&_p+p]:mt-4", "[&_p:not(li>p)]:mb-4", "[&_h3]:mb-4", "[&_li]:mb-1.5", "[&_ul]:mt-4 [&_ul]:mb-8 [&_ul]:ml-6 [&_ul]:list-disc");
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t.jobad_description_HL) {
    t9 = <h3 className="sr-only" data-source="lc">{t.jobad_description_HL}</h3>;
    $[16] = t.jobad_description_HL;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== job.content.task || $[19] !== job.content.taskHL) {
    t10 = job.content.task && <div className="mt-6">{job.content.taskHL && <h3 className="font-bold" data-source="job">{job.content.taskHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.task
      }} data-source="job" /></div>;
    $[18] = job.content.task;
    $[19] = job.content.taskHL;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== job.content.profile || $[22] !== job.content.profileHL) {
    t11 = job.content.profile && <div className="mt-6">{job.content.profileHL && <h3 className="font-bold" data-source="job">{job.content.profileHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.profile
      }} data-source="job" /></div>;
    $[21] = job.content.profile;
    $[22] = job.content.profileHL;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== job.content.offer || $[25] !== job.content.offerHL) {
    t12 = job.content.offer && <div className="mt-6">{job.content.offerHL && <h3 className="font-bold" data-source="job">{job.content.offerHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} data-source="job" /></div>;
    $[24] = job.content.offer;
    $[25] = job.content.offerHL;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t.jobad_inclusionHL) {
    t13 = <p className="mt-12 font-bold" data-source="lc">{t.jobad_inclusionHL}</p>;
    $[27] = t.jobad_inclusionHL;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = data.language === "CS" ? t.jobad_inclusion_textCZ : t.jobad_inclusion_text;
  let t15;
  if ($[29] !== t14) {
    t15 = <p data-source="lc">{t14}</p>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t.jobad_inclusion_textSub) {
    t16 = <p data-source="lc">{t.jobad_inclusion_textSub}</p>;
    $[31] = t.jobad_inclusion_textSub;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t13 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div>{t13}{t15}{t16}</div>;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t17 || $[41] !== t9) {
    t18 = <div className="overflow-wrap-break-word">{t9}{t10}{t11}{t12}{t17}</div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t17;
    $[41] = t9;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t.jobad_details_HL) {
    t19 = <h3 className="mb-6 font-bold text-2xl" data-source="lc">{t.jobad_details_HL}:</h3>;
    $[43] = t.jobad_details_HL;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t.jobad_details_contractType) {
    t20 = <th className="py-2 align-text-top font-normal" data-source="lc">{t.jobad_details_contractType}:</th>;
    $[45] = t.jobad_details_contractType;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== data.contract) {
    t21 = <td className="py-2 pl-2" data-source="job">{data.contract}</td>;
    $[47] = data.contract;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t20 || $[50] !== t21) {
    t22 = <tr>{t20}{t21}</tr>;
    $[49] = t20;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t.jobad_details_employmentType) {
    t23 = <th className="py-2 align-text-top font-normal" data-source="lc">{t.jobad_details_employmentType}:</th>;
    $[52] = t.jobad_details_employmentType;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== data.employmentType || $[55] !== t) {
    t24 = combineEmploymentTypes(data.employmentType, t);
    $[54] = data.employmentType;
    $[55] = t;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t24) {
    t25 = <td className="py-2 pl-2" data-source="job">{t24}</td>;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t23 || $[60] !== t25) {
    t26 = <tr>{t23}{t25}</tr>;
    $[59] = t23;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t.jobad_details_remote) {
    t27 = <th className="py-2 align-text-top font-normal" data-source="lc">{t.jobad_details_remote}:</th>;
    $[62] = t.jobad_details_remote;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== data.remote) {
    t28 = <td className="py-2 pl-2" data-source="job">{data.remote}</td>;
    $[64] = data.remote;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t27 || $[67] !== t28) {
    t29 = <tr>{t27}{t28}</tr>;
    $[66] = t27;
    $[67] = t28;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t.jobad_details_company) {
    t30 = <th className="py-2 align-text-top font-normal" data-source="lc">{t.jobad_details_company}:</th>;
    $[69] = t.jobad_details_company;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== data.company) {
    t31 = <td className="py-2 pl-2" data-source="job">{data.company}</td>;
    $[71] = data.company;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t30 || $[74] !== t31) {
    t32 = <tr>{t30}{t31}</tr>;
    $[73] = t30;
    $[74] = t31;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== t.jobad_details_jobNumber) {
    t33 = <th className="py-2 align-text-top font-normal" data-source="lc">{t.jobad_details_jobNumber}:</th>;
    $[76] = t.jobad_details_jobNumber;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== data.jobNumber) {
    t34 = <td className="py-2 pl-2" data-source="job">{data.jobNumber}</td>;
    $[78] = data.jobNumber;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t33 || $[81] !== t34) {
    t35 = <tr>{t33}{t34}</tr>;
    $[80] = t33;
    $[81] = t34;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  let t36;
  if ($[83] !== deadline || $[84] !== showDeadline || $[85] !== t.jobad_details_applicationDeadlineTitle) {
    t36 = showDeadline && <tr><th className="py-2 align-text-top font-normal" data-source="lc">{t.jobad_details_applicationDeadlineTitle}:</th><td className="py-2 pl-2" data-source="job">{deadline}</td></tr>;
    $[83] = deadline;
    $[84] = showDeadline;
    $[85] = t.jobad_details_applicationDeadlineTitle;
    $[86] = t36;
  } else {
    t36 = $[86];
  }
  let t37;
  if ($[87] !== t22 || $[88] !== t26 || $[89] !== t29 || $[90] !== t32 || $[91] !== t35 || $[92] !== t36) {
    t37 = <table className="mb-8 w-full break-words text-left md:w-2/3 lg:w-full lg:table-fixed"><tbody>{t22}{t26}{t29}{t32}{t35}{t36}</tbody></table>;
    $[87] = t22;
    $[88] = t26;
    $[89] = t29;
    $[90] = t32;
    $[91] = t35;
    $[92] = t36;
    $[93] = t37;
  } else {
    t37 = $[93];
  }
  let t38;
  if ($[94] !== showDeadline || $[95] !== t.jobad_details_applicationDeadline) {
    t38 = !showDeadline && <p data-source="lc">{t.jobad_details_applicationDeadline}</p>;
    $[94] = showDeadline;
    $[95] = t.jobad_details_applicationDeadline;
    $[96] = t38;
  } else {
    t38 = $[96];
  }
  let t39;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <PrivacyNotice className="mt-4" />;
    $[97] = t39;
  } else {
    t39 = $[97];
  }
  let t40;
  if ($[98] !== t19 || $[99] !== t37 || $[100] !== t38) {
    t40 = <section className="my-10 bg-primary p-10 text-white leading-6 lg:my-6">{t19}{t37}{t38}{t39}</section>;
    $[98] = t19;
    $[99] = t37;
    $[100] = t38;
    $[101] = t40;
  } else {
    t40 = $[101];
  }
  let t41;
  if ($[102] !== data) {
    t41 = toSimilarJob(data);
    $[102] = data;
    $[103] = t41;
  } else {
    t41 = $[103];
  }
  let t42;
  if ($[104] !== t41) {
    t42 = <WatchJobButton jobData={t41} />;
    $[104] = t41;
    $[105] = t42;
  } else {
    t42 = $[105];
  }
  let t43;
  if ($[106] !== job) {
    t43 = <ShareDropdown job={job} />;
    $[106] = job;
    $[107] = t43;
  } else {
    t43 = $[107];
  }
  let t44;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <PrintDropdown asButton={true} />;
    $[108] = t44;
  } else {
    t44 = $[108];
  }
  let t45;
  if ($[109] !== t42 || $[110] !== t43) {
    t45 = <section className="grid h-10 grid-flow-col grid-cols-3 gap-4">{t42}{t43}{t44}</section>;
    $[109] = t42;
    $[110] = t43;
    $[111] = t45;
  } else {
    t45 = $[111];
  }
  let t46;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <KununuBoxEcon />;
    $[112] = t46;
  } else {
    t46 = $[112];
  }
  let t47;
  if ($[113] !== t40 || $[114] !== t45) {
    t47 = <div className="flex flex-col">{t40}{t45}{t46}</div>;
    $[113] = t40;
    $[114] = t45;
    $[115] = t47;
  } else {
    t47 = $[115];
  }
  let t48;
  if ($[116] !== t18 || $[117] !== t47) {
    t48 = <div className={t8}>{t18}{t47}</div>;
    $[116] = t18;
    $[117] = t47;
    $[118] = t48;
  } else {
    t48 = $[118];
  }
  let t49;
  if ($[119] !== t3 || $[120] !== t48 || $[121] !== t7) {
    t49 = <section className="w-full px-6 py-10 md:px-10 md:py-20 print:hidden" id="job"><div className="mx-auto max-w-screen-xl">{t3}{t7}{t48}</div></section>;
    $[119] = t3;
    $[120] = t48;
    $[121] = t7;
    $[122] = t49;
  } else {
    t49 = $[122];
  }
  return t49;
}